export const groupBy = <T, K extends keyof any>(
  list: T[],
  getKey: (item: T) => K
) =>
  list.reduce((previous, currentItem) => {
    const group = getKey(currentItem)
    if (!previous[group]) previous[group] = []
    previous[group].push(currentItem)
    return previous
  }, {} as Record<K, T[]>)

export const toMap = <T, K extends keyof any>(
  list: T[],
  getKey: (item: T) => K
) =>
  list.reduce((map, currentItem) => {
    const key = getKey(currentItem)
    let group: T[]
    const preexGroup = map.get(key)
    if (preexGroup != null) {
      group = preexGroup
    } else {
      group = []
      map.set(key, group)
    }
    group.push(currentItem)
    return map
  }, new Map<K, T[]>())
